import {
  LanguageSwitcherListItem
} from "./chunk-CAXHTJFO.mjs";

// src/LanguageSwitcherList/LanguageSwitcherList.tsx
import { Box, SimpleGrid, List, Text } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var LanguageSwitcherList = ({
  listHeading,
  listItems,
  listAutoflow = "row",
  onItemClick,
  activeItems
}) => /* @__PURE__ */ jsxs(Box, {
  w: "100%",
  children: [
    /* @__PURE__ */ jsx(Text, {
      mb: 2,
      variant: "medium",
      fontWeight: "medium",
      "data-testid": "languageSwitcherListHeading",
      children: listHeading
    }),
    /* @__PURE__ */ jsx(List, {
      "data-testid": "languageSwitcherList",
      children: /* @__PURE__ */ jsx(SimpleGrid, {
        columns: { base: 1, md: 3, lg: 3 },
        spacingX: 6,
        autoFlow: listAutoflow,
        templateRows: {
          lg: `repeat(${Math.ceil(listItems.length / 3)}, 1fr)`
        },
        children: listItems.map((item) => /* @__PURE__ */ jsx(LanguageSwitcherListItem, {
          item,
          onItemClick,
          isActive: activeItems.includes(item.id)
        }, item.id))
      })
    })
  ]
});

export {
  LanguageSwitcherList
};
